/** M1-5: at most 2 frame-reported re-auths per rolling 5 minutes. */
export const BLOG_CMS_REAUTH_LIMIT = 2;
export const BLOG_CMS_REAUTH_WINDOW_MS = 300_000;

/**
 * Takes one re-auth slot. Entries at or before `now - window` are dropped; the slot is allowed
 * while fewer than the limit remain, and `now` is appended only when allowed. Only frame-reported
 * `reauth`s take slots: a timer or a user's Retry cannot loop, a 401 that renewal does not cure can.
 */
export function takeReauthSlot(
  history: readonly number[],
  now: number,
): { allowed: boolean; history: number[] } {
  const recent = history.filter((at) => at > now - BLOG_CMS_REAUTH_WINDOW_MS);
  if (recent.length >= BLOG_CMS_REAUTH_LIMIT) {
    return { allowed: false, history: [...history] };
  }
  return { allowed: true, history: [...recent, now] };
}
